
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class BinaryCascadeEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time, width, height } = pc;
         const spacing = (40 + layerIndex * 15) / (config.parallaxPatternDensity || 1.0);
        const { x1, x2 } = this.getGridBounds(pc, spacing );
        const scale = config.parallaxScale || 1.0;
        const speed = (250 + layerIndex * 80) * config.parallaxSpeed;

        ctx.fillStyle = pc.color;
        ctx.font = `bold ${12 * scale}px monospace`;

        const draw = () => {
            for (let x = x1; x <= x2; x += spacing) {
                const columnP = this.pseudoRandom(x);
                const scrollY = (time * speed * (0.8 + columnP * 0.4)) % (height * 2.5);
                
                const charCount = 30;
                for (let i = 0; i < charCount; i++) {
                    const y = -height + scrollY - i * 18 * scale;
                    if (y > -height && y < height) {
                        const alpha = 1 - (i / charCount);
                        ctx.globalAlpha = alpha * 0.8;
                        const char = this.pseudoRandom(x + i + Math.floor(time * 8)) > 0.5 ? "1" : "0";
                        ctx.fillText(char, x, y);
                    }
                }
            }
        };

        draw();
        this.applyGlow(pc, draw);
    }
}
